export default {
  "src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HealthReport.index.c1":'报告名称',
  "src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HealthReport.index.c2":'报告时间',
  "src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HealthReport.index.c3":'状态',
  "src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HealthReport.index.c4":'创建者',
  "src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HealthReport.index.c5":'生成时间',
  "src.pages.Customer.PersonalHealthReport.components.DownLoadModal.c1":'下载报告',
  "src.pages.Customer.PersonalHealthReport.components.DownLoadModal.c2":'复制全部连接',
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c1":"标签",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c2":"生成报告",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c3":"报告模板",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c4":"报告时间",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c5":"人员名单",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c6":"请添加人员名单",
  "src.pages.Customer.PersonalHealthReport.components.ExportReportDrawer.c7":"登录手机号",
  "src.components.ExportPersonalReportModal.index.c1":"生成个人健康报告",
  "src.components.ExportPersonalReportModal.index.c2":"生成模板",
  "src.components.ExportPersonalReportModal.index.c3":"根据模板生成",
  "src.components.ExportPersonalReportModal.index.c4":"第一步",
  "src.components.ExportPersonalReportModal.index.c5":"第二步",
  "src.components.ExportPersonalReportModal.index.c6":"第三步",
  "src.components.ExportPersonalReportModal.index.c7":"设置个人报告展示内容",
  "src.components.ExportPersonalReportModal.index.c8":"查看与编辑个人报告具体内容",
  "src.components.ExportPersonalReportModal.index.c9":"完成",
  "src.components.ExportPersonalReportModal.index.c10":"总结",
  "src.components.ExportPersonalReportModal.index.c11":"服务动态",
  "src.components.ExportPersonalReportModal.index.c12":"健康基础信息",
  "src.components.ExportPersonalReportModal.index.c13":"健康体征",
  "src.components.ExportPersonalReportModal.index.c14":"健康评估概况",
  "src.components.ExportPersonalReportModal.index.c15":"报告详情",
  "src.components.ExportPersonalReportModal.index.c16":"电话服务",
  "src.components.ExportPersonalReportModal.index.c17":"短信服务",
  "src.components.ExportPersonalReportModal.index.c18":"微信服务",
  "src.components.ExportPersonalReportModal.index.c19":"线下服务",
  "src.components.ExportPersonalReportModal.index.c20":"服务形式",
  "src.components.ExportPersonalReportModal.index.c21":"生活习惯",
  "src.components.ExportPersonalReportModal.index.c22":"既往史",
  "src.components.ExportPersonalReportModal.index.c23":"家族史",
  "src.components.ExportPersonalReportModal.index.c24":"用药记录",
  "src.components.ExportPersonalReportModal.index.c25":"内容",
  "src.components.ExportPersonalReportModal.index.c26":"注：以下所有信息从客户详情页中获取",
  "src.components.ExportPersonalReportModal.index.c27":"体重",
  "src.components.ExportPersonalReportModal.index.c28":"血压",
  "src.components.ExportPersonalReportModal.index.c29":"餐前血糖",
  "src.components.ExportPersonalReportModal.index.c30":"餐后血糖",
  "src.components.ExportPersonalReportModal.index.c31":"空腹血糖",
  "src.components.ExportPersonalReportModal.index.c32":"健康体征",
  "src.components.ExportPersonalReportModal.index.c33":"健康小屋报告",
  "src.components.ExportPersonalReportModal.index.c34":"检测时间",
  "src.components.ExportPersonalReportModal.index.c35":"导出份数",
  "src.components.ExportPersonalReportModal.index.c36":"体检机构",
  "src.components.ExportPersonalReportModal.index.c37":"体检时间",
  "src.components.ExportPersonalReportModal.index.c38":"体检报告",
  "src.components.ExportPersonalReportModal.index.c39":"健康评估报告",
  "src.components.ExportPersonalReportModal.index.c40":"日期区间",
  "src.components.ExportPersonalReportModal.index.c41":"健康指标明细",





}
